import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const BackButtonHandler = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const backShown = useRef(false);

  useEffect(() => {
    const tg = window.Telegram.WebApp;
    const isHome = location.pathname === '/';

    if (!isHome && !backShown.current) {
      tg.MainButton.hide();       
      tg.BackButton.show();
      tg.BackButton.onClick(() => navigate(-1));
      backShown.current = true;
    }

    if (isHome && backShown.current) {
      tg.BackButton.hide();
      tg.BackButton.offClick(() => navigate(-1));
      backShown.current = false;
    }

  }, [location, navigate]);

  return null;
};

export default BackButtonHandler;